import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

// Small wrapper around useBreakpoints to provide presets and more readable names
export function useResponsive() {
  const breakpoints = useBreakpoints(breakpointsTailwind)
  const isMobile = breakpoints.smaller('lg')
  const isDesktop = breakpoints.greaterOrEqual('lg')

  const isSmallScreen = breakpoints.smallerOrEqual('sm')
  const isMediumScreen = breakpoints.greaterOrEqual('md')
  const isLargeScreen = breakpoints.greaterOrEqual('xl')
  const isVeryLargeScreen = breakpoints.greaterOrEqual('2xl')

  return {
    breakpoints,
    isMobile,
    isDesktop,
    isLargeScreen,
    isVeryLargeScreen,
    isSmallScreen,
    isMediumScreen,
  }
}
